import React, { useEffect, useState } from 'react'
import { SearchInput } from 'components/SearchInput/searchInput'
import Button from 'components/Button'
import PlusIcon from 'images/PlusIcon'
import { definitions } from 'generated/apiTypes'
import { ProjectCard } from './components/ProjectCard/projectCard'
import { createProjectRequest, getProjectsRequest } from 'services/apiRequests'
import {
  selectProjectsList,
  setGetProjects,
  setProjectsListPage,
  addProjectsListPage,
  setProjectsList,
} from 'store/projectsListSlice'
import { setBlockingWindow } from 'store/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useCopyProject from 'components/hooks/useCopyProject'
import Dropdown from 'components/Dropdown/Dropdown'
import { handleStorage } from 'services/handleStorage'
import { IDeleteConfirmParams } from 'store/types'

const pageLimit = 50
const scrollThreshold = 0.8

const Projects: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchValue, setSearchValue] = useState<string | undefined>()
  const [inputValue, setInputValue] = useState<string | undefined>()
  const [projectsArr, setProjectsArr] = useState<definitions['ProjectCalculations'][]>()
  const [projectsFilterValue, setProjectsFilterValue] = useState<{ name: 'Мои проекты' | 'Все проекты' }>(
    handleStorage.getShowAllProjects()
      ? { name: 'Все проекты' }
      : {
          name: 'Мои проекты',
        },
  )
  const [pageIx, setPageIx] = useState<number>(0)
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const [isNext, setIsNext] = useState<boolean>()
  const projectsList = useSelector(selectProjectsList)
  const [copyProjectID, setCopyProjectID] = useState<string | undefined>()
  const pattern = /(\d{2})-(\d{2})-(\d{4})/
  const timerId = React.useRef<ReturnType<typeof setTimeout>>()

  useCopyProject(copyProjectID)
  const fetchProjectsByPage = (page: number, userId: string | undefined, searchStr: string | undefined) => {
    getProjectsRequest(pageLimit, page * pageLimit, searchStr, userId).then((res: any) => {
      setIsNext(!!res.data.next)
      dispatch(
        setProjectsListPage({
          pageIx: page,
          pageLimit,
          list: res.data.results.map((item: definitions['Project']) => {
            return {
              ...item,
              updated: item.updated.replace(pattern, '$3-$2-$1'),
            }
          }),
        }),
      )
      dispatch(setGetProjects(false))
      setPageLoading(false)
    })
  }

  const fetchProjects = (userId: string | undefined, searchStr: string | undefined) => {
    getProjectsRequest(pageLimit, undefined, searchStr, userId).then((res: any) => {
      setIsNext(!!res.data.next)
      dispatch(
        setProjectsList(
          res.data.results.map((item: definitions['Project']) => {
            return {
              ...item,
              updated: item.updated.replace(pattern, '$3-$2-$1'),
            }
          }),
        ),
      )
      dispatch(setGetProjects(false))
      setPageLoading(false)
      setPageIx(0)
    })
  }
  const createProject = () => {
    createProjectRequest().then((res: any) => {
      //setPageIx(0)
      res.data && openProject(res.data.id)
    })
  }
  const openProject = (projectID: string) => {
    navigate(`/project/${projectID}`)
    // getProjectByIDRequest(projectID).then((res: any) => dispatch(setProject(res.data)))
  }
  const deleteProject = (projectID: string, projectName: string) => {
    dispatch(
      setBlockingWindow({
        type: 'DELETE_CONFIRM',
        params: { objectType: 'PROJECT', objectID: projectID, objectName: projectName } as IDeleteConfirmParams,
      }),
    )
    // deleteProjectByIDRequest(projectID).then(dispatch(setProjectsList(projectsList.filter((projectMeta: any)=> projectMeta.id!==projectID))))
  }

  /*useEffect(() => {
    if (getProjects || !projectsList.length) fetchProjects(pageIx)
  }, [])*/

  useEffect(() => {
    document.addEventListener('scroll', handleScroll)

    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [pageLoading, isNext, pageIx])

  useEffect(() => {
    const userId = projectsFilterValue.name === 'Мои проекты' ? handleStorage.getUserId() || undefined : undefined
    if (pageIx > 0) fetchProjectsByPage(pageIx, userId, searchValue)
  }, [pageIx])

  useEffect(() => {
    const userId = projectsFilterValue.name === 'Мои проекты' ? handleStorage.getUserId() || undefined : undefined
    fetchProjects(userId, searchValue)
  }, [projectsFilterValue.name, searchValue])

  const handleScroll = () => {
    if (window.innerHeight + window.scrollY >= scrollThreshold * document.body.offsetHeight && !pageLoading && isNext) {
      setPageLoading(true)
      dispatch(addProjectsListPage(pageLimit))
      setPageIx(pageIx + 1)
    }
  }

  const onProjectsFilterChanged = (value: { name: 'Мои проекты' | 'Все проекты' }) => {
    setProjectsFilterValue(value)
    if (value.name === 'Все проекты') {
      handleStorage.setShowAllProjects()
    } else {
      handleStorage.removeShowAllProjects()
    }
  }

  React.useEffect(() => {
    timerId.current = setInterval(() => {
      setSearchValue(inputValue)
      clearInterval(timerId.current)
    }, 2000)
    return () => {
      if (timerId.current) {
        clearInterval(timerId.current)
      }
    }
  }, [inputValue])

  const onEnter = () => {
    setSearchValue(inputValue)
  }

  return (
    <div className={'main-page__container'}>
      <div className={'main-page-content__container'}>
        <div className={'project-list__projects-header'}>
          <div className={'project-list__my-projects-wrapper'}>
            <h1 className={'project-list__projects-title'}>Проекты</h1>
            <Dropdown
              options={[{ name: 'Мои проекты' }, { name: 'Все проекты' }]}
              displayedField={'name'}
              selectedValue={projectsFilterValue}
              setSelectedValue={onProjectsFilterChanged}
            />
          </div>
          <div className={'project-list__projects-btn'}>
            <SearchInput setValue={setInputValue} onEnter={onEnter} placeholder={'Название проекта или id...'} />
            <Button className={'with-icon'} onClick={createProject}>
              <PlusIcon />
              Создать проект
            </Button>
          </div>
        </div>
        <div className={'project-list__projects-body'}>
          {projectsList.length > 0 ? (
            projectsList
              .filter((item) => item.name)
              .map((projectMeta: definitions['ProjectCalculations']) => (
                <ProjectCard
                  key={projectMeta.id}
                  id={projectMeta.id}
                  title={projectMeta.name}
                  owner={`${projectMeta.author?.first_name || ''} ${projectMeta.author?.last_name || ''}`}
                  date={projectMeta.updated}
                  notVisited={projectMeta.not_visited_task_states}
                  deleteProject={deleteProject}
                  copyProject={setCopyProjectID}
                  onClick={() => openProject(projectMeta.id)}
                />
              ))
          ) : (
            <span className={'project-list__loading-message normal-text'}>
              По заданным условиям поиска проекты не найдены
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default Projects
